
































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ContentListData } from '@/types';
import { Getter } from 'vuex-class';

@Component({
  name: 'content-type-list',
})
export default class extends Vue {
  private tag = this.$options.name as string;

  @Prop({type: Object, required: true})
  private readonly data!: ContentListData;

  @Getter('dataManagement/themeColor')
  private themeColor!: CSSStyleDeclaration['color'];

  @Getter('dataManagement/cardBgColor')
  private cardBgColor!: CSSStyleDeclaration['color'];

  private addHoverColor(event: MouseEvent, isHovered: boolean): void {
    const target: HTMLDivElement = event.target as HTMLDivElement;
    if (isHovered && this.themeColor) {
      target.style.backgroundColor = this.themeColor;
      target.style.color = 'white';
    } else {
      target.style.backgroundColor = 'white';
      target.style.color = 'inherit';
    }
  }

  private isContentItemsSomeFilled(content: ContentListData['content']): boolean {
    return content.some && content.some((item: string) => {
      return Boolean(item);
    });
  }
}
